import { SettingsPage } from "@/pages/SettingsPage";
import { appRouterPaths } from "@/services/navigation";
import type { RouteProps } from "react-router-dom";

export const settingsPageRoute: RouteProps = {
  path: appRouterPaths.settings,
  element: <SettingsPage />,
};
